import { FC, SyntheticEvent, useCallback } from "react";
import { Radio, Typography } from "theme";

import { FormControl, FormControlLabel, FormGroup, Grid2 } from "@mui/material";
import { styled } from "@mui/material/styles";

export type PrepaymentGroupProps = {
  name: string;
  options: {
    label: string;
    value: string;
  }[];
  onChange: (value: string) => void;
  value?: string;
};

const LabelWrapper: FC<{ option: string }> = ({ option }) => {
  return (
    <Typography textTransform="uppercase" variant="body1">
      {option}
    </Typography>
  );
};

const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => {
  return {
    "&.MuiFormControlLabel-root": {
      display: "flex",
      margin: 0,
      justifyContent: "space-between",
      alignItems: "center",
      columnGap: theme.spacing(1.5),
    },
  };
});

const SelectionRadioGroup: FC<PrepaymentGroupProps> = ({ onChange, options, name, value }) => {
  const handleChange = useCallback(
    (e: SyntheticEvent) => {
      const changedValue = (e.currentTarget as HTMLInputElement).value;

      onChange(changedValue);
    },
    [onChange],
  );

  return (
    <FormControl fullWidth>
      <FormGroup>
        <Grid2 container flexDirection="row" columnGap={4}>
          {options.map((option) => {
            return (
              <StyledFormControlLabel
                key={option.value}
                labelPlacement="start"
                name={name}
                value={String(option.value)}
                control={<Radio />}
                label={<LabelWrapper option={option.label} />}
                checked={value === String(option.value)}
                onChange={handleChange}
              />
            );
          })}
        </Grid2>
      </FormGroup>
    </FormControl>
  );
};

export default styled(SelectionRadioGroup)(() => {
  return {};
});
